import { css } from 'styled-components';

export default {
  text: css`
    font-size: 14px;
    font-family: Monaco, monospace;
  `
};



// WEBPACK FOOTER //
// ./src/utils/styles.js